@let principal = principal$ | async;
<elder-shell class="full">
  <!-- Left Side Content -->
  <div *elderShellSideLeft class="layout-col full">
    <!-- App Header -->
    <elder-app-header
      title="{{ 'main.title' | translate }}"
      svgIcon="mexus-logo"
      version="{{ version }}"
    >
      <elder-expand-toggle-button class="p-sm" [elderTogglePanelTrigger]="navMenu">
        @if (principal) {
          <div class="layout-col p-sm">
            <div>{{ principal.name }}</div>
            <div class="mat-caption">{{ principal.username }}</div>
          </div>
        }
      </elder-expand-toggle-button>
    </elder-app-header>

    <elder-toggle-panel class="flex elder-main-nav-panel" #navMenu="elderTogglePanel">
      <!-- App Navigation links -->
      <app-main-nav-menu *elderTogglePanelPrimary class="flex"></app-main-nav-menu>

      <!-- Secondary Navigation -->
      <elder-nav-list *elderTogglePanelSecondary class="flex">
        @if (principal) {
          <elder-nav-link icon="account_circle" title="Account" href="{{ accountUrl }}">
          </elder-nav-link>

          <elder-nav-link
            icon="exit_to_app"
            title="Logout {{ principal.username }}"
            (click)="logout()"
          >
          </elder-nav-link>
        }

        <mat-divider></mat-divider>

        <elder-appearance-settings></elder-appearance-settings>
      </elder-nav-list>
    </elder-toggle-panel>
  </div>
  <ng-template elderShellStaticNavSlot>
    <app-main-nav-menu elderRailNav></app-main-nav-menu>
  </ng-template>
</elder-shell>
